/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ClassificationOverrideRequestLabel } from './classificationOverrideRequestLabel';

/**
 * Manual classification override.
 *
 * ``label=None`` clears the override and lets the model-side
 * classification (if any) win.
 */
export interface ClassificationOverrideRequest {
  label?: ClassificationOverrideRequestLabel;
}
